import React from "react";
import Day from "./Day/Day";

class WorkingDays extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: {
                "monday": {label: "Monday"},
                "tuesday": {label: "Tuesday"},
                "wednesday":{label: "Wednesday"},
                "thursday": {label: "Thursday"},
                "friday": {label: "Friday"},
                "saturday": {label: "Saturday"},
                "sunday": {label: "Sunday"}
            }
        }
    }

    render() {
        return (
            <div class="workingDaysContainer">
                <div class="sectionHeader">
                    <label>Working Days</label>
                </div>
                <div class="sectionBody">
                    <div class="workingDays">
                        {Object.keys(this.state.days).map(k => <Day day={{...this.state.days[k], id: k, isActive: Boolean(this.props.days[k])}} />)}
                    </div>
                </div>
            </div>
        );
    }
}

export default WorkingDays;